/* Aurora customizer: cassette, side A and side B, with printable and unprintable areas marked.
   The shell is drawn in a 100 x 63 space; everything is proportion, no measurement is claimed. */
(function () {
  'use strict';
  var L = window.AuroraCZ;

  var K = 5.6;
  var POS = { a: { x: 60, y: 50 }, b: { x: 380, y: 358 } };
  var W = 100, H = 63;

  var SHELL = new Path2D('M3.2 0 H96.8 Q100 0 100 3.2 V59.8 Q100 63 96.8 63 H3.2 Q0 63 0 59.8 V3.2 Q0 0 3.2 0 Z');
  function rr(x, y, w, h, r) {
    return 'M' + (x + r) + ' ' + y + ' H' + (x + w - r) + ' Q' + (x + w) + ' ' + y + ' ' + (x + w) + ' ' + (y + r) +
      ' V' + (y + h - r) + ' Q' + (x + w) + ' ' + (y + h) + ' ' + (x + w - r) + ' ' + (y + h) + ' H' + (x + r) +
      ' Q' + x + ' ' + (y + h) + ' ' + x + ' ' + (y + h - r) + ' V' + (y + r) + ' Q' + x + ' ' + y + ' ' + (x + r) + ' ' + y + ' Z';
  }
  var LABEL = { x: 7, y: 4, w: 86, h: 37 };
  var WIN = { x: 29, y: 17, w: 42, h: 20 };
  var P_WINDOW = new Path2D(rr(WIN.x, WIN.y, WIN.w, WIN.h, 2));
  var P_LABEL = new Path2D(rr(LABEL.x, LABEL.y, LABEL.w, LABEL.h, 1.6) + ' ' + rr(WIN.x, WIN.y, WIN.w, WIN.h, 2));   // evenodd: label minus window
  var P_MECH = new Path2D('M14 41.5 H86 L81 63 H19 Z');
  var SCREWS = [[5, 5], [95, 5], [5, 58], [95, 58], [50, 46]];
  var P_EDGE = new Path2D(rr(0, 0, W, H, 3.2) + ' ' + rr(1.6, 1.6, W - 3.2, H - 3.2, 2));

  function shade(hex, f) {
    var n = parseInt(hex.slice(1), 16);
    function ch(v) { return Math.max(0, Math.min(255, Math.round(v * f))); }
    return 'rgb(' + ch((n >> 16) & 255) + ',' + ch((n >> 8) & 255) + ',' + ch(n & 255) + ')';
  }
  function hatch(c, path, rule) {
    c.save();
    c.clip(path, rule || 'nonzero');
    c.strokeStyle = 'rgba(194,64,47,0.65)'; c.lineWidth = 1.1 / K;
    var s = 7 / K;
    c.beginPath();
    for (var t = -130; t < 230; t += s) { c.moveTo(t, 0); c.lineTo(t - 130, 130); }
    c.stroke();
    c.restore();
  }
  function hub(c, x, y) {
    c.beginPath(); c.arc(x, y, 7.2, 0, 7); c.fillStyle = '#4a3324'; c.fill();
    c.beginPath(); c.arc(x, y, 3.3, 0, 7); c.fillStyle = '#e8e6e0'; c.fill();
    c.fillStyle = '#2b2f2e';
    for (var i = 0; i < 6; i++) { var a = i * Math.PI / 3; c.fillRect(x + Math.cos(a) * 2.2 - 0.45, y + Math.sin(a) * 2.2 - 0.45, 0.9, 0.9); }
  }

  function init(root) {
    var t = L.i18n(root);
    var canvas = root.querySelector('[data-cz-canvas]');
    var ctx = canvas.getContext('2d');
    var empty = root.querySelector('[data-cz-empty]');
    var status = root.querySelector('[data-cz-status]');
    var hint = root.querySelector('[data-cz-hint]');
    var dlBtn = root.querySelector('[data-cz-download]');
    var mailLink = root.querySelector('[data-cz-mail]');
    var legend = root.querySelector('[data-cz-legend]');
    var mail = root.getAttribute('data-mail') || '';

    var st = { sel: 'a', base: '#8f9b9a', showZones: true,
      side: { a: { pic: null, pl: new L.Placement('cover') }, b: { pic: null, pl: new L.Placement('cover') } } };
    function say(m, k) { L.say(status, m, k); }

    function paintShell(c, key, opts) {
      var s = st.side[key], p = POS[key];
      c.save();
      c.translate(p.x, p.y); c.scale(K, K);

      c.save();
      if (opts.shadow) { c.shadowColor = 'rgba(15,32,25,0.25)'; c.shadowBlur = 28 / K; c.shadowOffsetY = 12 / K; }
      c.fillStyle = st.base; c.fill(SHELL);
      c.restore();

      // the mechanism area, a slightly different tone with its openings
      c.fillStyle = shade(st.base, 0.84); c.fill(P_MECH);
      c.fillStyle = '#1b1f1e';
      c.beginPath(); c.rect(41, 56.4, 18, 4.6); c.fill();
      c.beginPath(); c.rect(23, 52.4, 6.4, 3.6); c.fill();
      c.beginPath(); c.rect(70.6, 52.4, 6.4, 3.6); c.fill();
      c.beginPath(); c.arc(30, 46.2, 0.9, 0, 7); c.arc(70, 46.2, 0.9, 0, 7); c.fill();

      // the picture, held inside the label area (window left open)
      if (s.pic) {
        c.save();
        c.clip(P_LABEL, 'evenodd');
        L.drawPic(c, s.pic, s.pl, LABEL);
        c.restore();
      } else if (opts.shadow) {
        c.save(); c.fillStyle = 'rgba(20,32,26,0.5)';
        c.font = '600 ' + (7.4) + 'px "Noto Sans TC","PingFang TC","Microsoft JhengHei",sans-serif';
        c.textAlign = 'center'; c.textBaseline = 'middle';
        c.fillText(key === 'a' ? t.sideA : t.sideB, 50, 10.5);
        c.restore();
      }

      // the window with the tape and reels
      c.save();
      c.clip(P_WINDOW);
      c.fillStyle = '#151918'; c.fillRect(WIN.x, WIN.y, WIN.w, WIN.h);
      c.fillStyle = '#5a3c28'; c.fillRect(39, 24.4, 22, 5.2);
      hub(c, 39, 27); hub(c, 61, 27);
      var g = c.createLinearGradient(0, WIN.y, 0, WIN.y + WIN.h);
      g.addColorStop(0, 'rgba(255,255,255,0.16)'); g.addColorStop(0.45, 'rgba(255,255,255,0)');
      c.fillStyle = g; c.fillRect(WIN.x, WIN.y, WIN.w, WIN.h);
      c.restore();
      c.lineWidth = 0.4; c.strokeStyle = 'rgba(0,0,0,0.45)'; c.stroke(P_WINDOW);

      SCREWS.forEach(function (sc) {
        c.beginPath(); c.arc(sc[0], sc[1], 1.7, 0, 7); c.fillStyle = shade(st.base, 0.6); c.fill();
        c.beginPath(); c.moveTo(sc[0] - 1, sc[1]); c.lineTo(sc[0] + 1, sc[1]); c.lineWidth = 0.3; c.strokeStyle = 'rgba(0,0,0,0.5)'; c.stroke();
      });

      // gloss
      c.save(); c.clip(SHELL);
      var gl = c.createLinearGradient(0, 0, 100, 63);
      gl.addColorStop(0, 'rgba(255,255,255,0.18)'); gl.addColorStop(0.4, 'rgba(255,255,255,0)');
      gl.addColorStop(1, 'rgba(0,0,0,0.10)');
      c.fillStyle = gl; c.fillRect(0, 0, 100, 63);
      c.restore();

      if (opts.shadow) {
        c.lineWidth = 0.35; c.strokeStyle = 'rgba(15,32,25,0.28)'; c.stroke(SHELL);
        if (st.showZones) {
          [P_WINDOW, P_MECH].forEach(function (z) { c.fillStyle = 'rgba(194,64,47,0.14)'; c.fill(z); hatch(c, z); });
          c.fillStyle = 'rgba(194,64,47,0.14)'; c.fill(P_EDGE, 'evenodd'); hatch(c, P_EDGE, 'evenodd');
          SCREWS.forEach(function (sc) {
            var z = new Path2D(); z.arc(sc[0], sc[1], 2.6, 0, 7);
            c.fillStyle = 'rgba(194,64,47,0.18)'; c.fill(z); hatch(c, z);
          });
          c.fillStyle = 'rgba(30,201,192,0.07)'; c.fill(P_LABEL, 'evenodd');
          c.save(); c.setLineDash([1.6, 1.1]); c.lineWidth = 0.4; c.strokeStyle = 'rgba(14,150,140,0.95)';
          c.stroke(P_LABEL); c.restore();
        }
        if (st.sel === key) {
          c.setLineDash([]);
          c.lineWidth = 0.6; c.strokeStyle = 'rgba(30,201,192,0.95)';
          c.stroke(new Path2D(rr(-1.4, -1.4, W + 2.8, H + 2.8, 4.4)));
        }
      }
      c.restore();
    }

    var queued = false;
    function draw() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        paintShell(ctx, 'a', { shadow: true }); paintShell(ctx, 'b', { shadow: true });
      });
    }

    var ctl = L.controls(root, draw);
    function anyPic() { return st.side.a.pic || st.side.b.pic; }
    function refreshUI() {
      var cur = st.side[st.sel];
      ctl.bind(cur.pic ? cur.pl : null);
      root.querySelectorAll('[data-side]').forEach(function (b) {
        var on = b.getAttribute('data-side') === st.sel;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      dlBtn.disabled = !anyPic(); empty.hidden = !!anyPic(); hint.hidden = !anyPic();
    }
    function updateMail() {
      L.mail(mailLink, mail, t.mailSubject, (t.mailBody || '') + '\n\n' + L.label(root, '[data-base].is-on'));
    }

    root.querySelectorAll('[data-upload]').forEach(function (drop) {
      var key = drop.getAttribute('data-upload');
      L.bindUpload(drop, drop.querySelector('input'), function (file) {
        L.loadFile(file, t, say, function (pic) {
          st.side[key].pic = pic; st.side[key].pl.reset();
          drop.classList.add('is-filled'); drop.querySelector('span').textContent = file.name;
          st.sel = key; refreshUI(); draw();
        });
      });
    });
    root.querySelectorAll('[data-side]').forEach(function (b) {
      b.addEventListener('click', function () { st.sel = b.getAttribute('data-side'); refreshUI(); draw(); });
    });
    var baseBtns = root.querySelectorAll('[data-base]');
    baseBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.base = b.getAttribute('data-base'); L.radio(baseBtns, b); updateMail(); draw(); }); });
    root.querySelectorAll('[data-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-toggle'); st[k] = !st[k];
        b.classList.toggle('is-on', st[k]); b.setAttribute('aria-pressed', st[k] ? 'true' : 'false');
        if (legend) legend.hidden = !st.showZones;
        draw();
      });
    });

    L.dragger(canvas, {
      pick: function (x, y) {
        var hit = ['b', 'a'].filter(function (k) {
          var p = POS[k]; return x >= p.x && x <= p.x + W * K && y >= p.y && y <= p.y + H * K;
        })[0];
        if (hit && hit !== st.sel) { st.sel = hit; refreshUI(); draw(); }
      },
      current: function () {
        var s = st.side[st.sel]; if (!s.pic) return null;
        return { pl: s.pl, w: LABEL.w * K, h: LABEL.h * K };
      },
      onZoom: function () { ctl.refresh(); },
      onChange: draw
    });

    dlBtn.addEventListener('click', function () {
      if (!anyPic()) return;
      var k = 1.5, x0 = POS.a.x, y0 = POS.a.y, w = POS.b.x + W * K - x0, h = POS.b.y + H * K - y0;
      var out = document.createElement('canvas');
      out.width = Math.round(w * k); out.height = Math.round(h * k);
      var c = out.getContext('2d'); c.scale(k, k); c.translate(-x0, -y0);
      paintShell(c, 'a', { shadow: false }); paintShell(c, 'b', { shadow: false });
      L.download(out, (t.fileName || 'aurora-cassette-preview') + '.png');
    });

    refreshUI(); updateMail(); draw();
  }

  L.boot('[data-aurora-cz-cassette]', init);
})();
